import { environment } from "../../environments/environment";

interface CognitoConfig {
  userPoolId: string;
  clientId: string;
}

export function cognitoConfig(): CognitoConfig {
  if (typeof window !== "undefined") {
    const w = window as unknown as {
      __SUPPLIER_COGNITO_USER_POOL_ID__?: string;
      __SUPPLIER_COGNITO_CLIENT_ID__?: string;
    };
    const poolId =
      w.__SUPPLIER_COGNITO_USER_POOL_ID__?.trim() ||
      environment.cognitoUserPoolId;
    const clientId =
      w.__SUPPLIER_COGNITO_CLIENT_ID__?.trim() ||
      environment.cognitoClientId;
    if (poolId && clientId) {
      return { userPoolId: poolId, clientId };
    }
  }
  return {
    userPoolId: environment.cognitoUserPoolId,
    clientId: environment.cognitoClientId,
  };
}
